export function formCardClass(isEditing: boolean, baseClassName = 'erp-card'): string {
  return isEditing ? `${baseClassName} erp-form-card--editing` : baseClassName;
}
